import { render } from "./ModalWriteReview.vue?vue&type=template&id=7027e35e&scoped=true"
import script from "./ModalWriteReview.vue?vue&type=script&lang=js"
export * from "./ModalWriteReview.vue?vue&type=script&lang=js"

import "./ModalWriteReview.vue?vue&type=style&index=0&id=7027e35e&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7027e35e"]])

export default __exports__